module.exports = __webpack_public_path__ + "files/reasink.225b14d7d27816c0ff39ca05b85bb282.pdf";